import React, {useState} from "react";
import PropTypes from "prop-types";
import {Button, Modal, Spinner} from "react-bootstrap";
import FalconCloseButton from "../../../common/FalconCloseButton";
import {useSelector} from "react-redux";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import IconButton from "../../../common/IconButton";
import {customerCancelEmpowermentAsync} from "../../../../app/store/reducers/roaming/roamingEmpowermentReducer";
import {selectCurrentCertificate} from "../../../../app/store/reducers/eimzo/eimzoReducer";
import SignActionWithSelectCertificatWrapper from "../components/SignActionWithSelectCertificatWrapper";


const CustomerCancelEmpowerment = ({id, ...props}) => {
    const lang = useSelector(selectLang);
    const t = Translate;
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const currentCertificate = useSelector(selectCurrentCertificate);


    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const customerCancelEmpowermentHandler = () => {
        setLoading(true);
        customerCancelEmpowermentAsync(currentCertificate, id, lang)
            .then(response => {
                handleClose();
                setLoading(false);
            })
            .catch(errors => {
                setLoading(false)
            })
    };

    return (
        <>
            <IconButton
                onClick={handleShow}
                variant="falcon-danger"
                size="sm"
                iconClassName="me-1"
                icon={'ban'}
                {...props}
            >{t(lang, 'roaming.empowerment.customer_cancel_button')}</IconButton>

            <Modal show={show} onHide={handleClose}>
                    <Modal.Header>
                        <Modal.Title>{t(lang, "roaming.empowerment.customer_cancel_modal.title")}</Modal.Title>
                        <FalconCloseButton onClick={() => handleClose()}/>
                    </Modal.Header>
                    <Modal.Body>{t(lang, "roaming.empowerment.customer_cancel_modal.body")}</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t(lang, "roaming.empowerment.cancel_button")}
                        </Button>
                        <SignActionWithSelectCertificatWrapper>
                            <Button 
                                variant="primary"
                                className="d-flex align-items-center"
                                onClick={customerCancelEmpowermentHandler}
                                disabled={loading}
                            >
                                {loading && <Spinner className="me-2" animation="border" role="status" size="sm"/>}
                                {t(lang, 'roaming.empowerment.customer_cancel_button')}
                            </Button>
                        </SignActionWithSelectCertificatWrapper>

                    </Modal.Footer>
            </Modal>
        </>
    )
};

CustomerCancelEmpowerment.propTypes = {
    id: PropTypes.string,
};
CustomerCancelEmpowerment.defaultProps = {
    id: "",
};

export default CustomerCancelEmpowerment;